
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/breadcrumbs",
      function () {
        return require("private-next-pages/components/breadcrumbs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/breadcrumbs"])
      });
    }
  